import { AllRequestsParamsDto } from '@/domain/requestsPage';

import { ORDER, ORDER_BY } from '../enums/common';
import { DELETION_STATUS, REQUEST_STATUS } from '../enums/requestsPage';

export const FQ_NODE_ENV = process.env.REACT_APP_FQ_NODE_ENV;
export const FQ_BASE_API_URL = process.env.REACT_APP_FQ_BASE_API_URL;
export const APP_VERSION = process.env.REACT_APP_LAST_COMMIT_HASH;
export const MIXPANEL_TOKEN_PRODUCTION = '5601f0ba756ecf02b96f55c0e09cf802';
export const MIXPANEL_TOKEN_STAGE = '6e1d20c23c09e30bd4c33ca6480c9ec4';
export const MIXPANEL_TOKEN_DEV = '73030555c89b3bb323ee81cc15fe1e71';
export const APP_RELEASE_VERSION = '4.5';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';
export const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID ?? '';
export const APPLE_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI ?? '';
export const SSO_NAME_PLACEHOLDER = 'NotProvided';
export const HOT_JAR_ID_DEV = '3854362';
export const HOT_JAR_ID_PROD = '3840341';
export const HOTJAR_SNIPPET_VERSION = 6;

export const FIRST_PAGE = 1;
export const INITIAL_PAGINATION = {
    page: FIRST_PAGE,
    pageSize: 10,
};
export const INITIAL_PAGINATION_WITHOUT_PAGE_SIZE = {
    page: FIRST_PAGE,
    pageSize: 100,
};

export const LETTERS_ONLY_REGEX = /^[\p{L}]+$/u;
export const MAX_PAGE_SIZE = 5000;
export const LOADER_SIZE = {
    small: 20,
};
export const SEARCH_DEBOUNCE_TIME = 500;
export const LOCALE_NAME_LENGTH = 2;

//New request summary
export const DEFAULT_NUMBER_OF_DAYS = 0;
export const ONE_DAY = 1;

export const CALENDAR_REQUESTS_PARAMS: AllRequestsParamsDto = {
    order: ORDER.ASC,
    orderBy: ORDER_BY.FROM,
    page: 1,
    pageSize: 1000,
    status: [REQUEST_STATUS.ACCEPTED, REQUEST_STATUS.NEW, DELETION_STATUS.DELETION_REQUEST],
};

export const CALENDAR_URL = 'https://calendar.google.com/calendar/r';
